import React from 'react'

import * as S from './ToggleAmountTypeInput.styles'
import { ToggleAmountPolarityProps, ToggleInputPolarity } from './ToggleAmountTypeInput.types'

const nextPolarityBasedOnCurrentPolarity: Record<number, ToggleInputPolarity> = {
  [ToggleInputPolarity.negative]: ToggleInputPolarity.positive,
  [ToggleInputPolarity.positive]: ToggleInputPolarity.negative,
}

function ToggleAmountPolarity({
  polarity,
  small,
  onChange,
}: ToggleAmountPolarityProps): JSX.Element {
  const handleNextPolarity = () => {
    onChange(nextPolarityBasedOnCurrentPolarity[polarity])
  }

  return (
    <S.ToggleButtonContainer small={small} margin={8} onClick={handleNextPolarity}>
      <S.ToggleItem
        className={polarity === ToggleInputPolarity.negative ? 'active' : undefined}
        active={polarity === ToggleInputPolarity.negative}
        small={small}
      >
        -
      </S.ToggleItem>
      <S.ToggleItem
        className={polarity === ToggleInputPolarity.positive ? 'active' : undefined}
        active={polarity === ToggleInputPolarity.positive}
        small={small}
      >
        +
      </S.ToggleItem>
    </S.ToggleButtonContainer>
  )
}

export { ToggleAmountPolarity }
